// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:03 GMT

export const website_mobile_tailwind_config = {
  spacing: {
    "cta-searchbar-1-height": "2.5rem",
    "dynamic-mobile-cta-searchbar-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-searchbar-1-height": "3.7037037037037037vh",
    "cta-searchbar-1-width": "21rem",
    "dynamic-mobile-cta-searchbar-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-searchbar-1-width": "17.5vw",
    "cta-searchbar-2-height": "2.5rem",
    "dynamic-mobile-cta-searchbar-2-height": "5.617977528089888vh",
    "dynamic-desktop-cta-searchbar-2-height": "3.7037037037037037vh",
    "cta-searchbar-2-width": "3.875rem",
    "dynamic-mobile-cta-searchbar-2-width": "17.22222222222222vw",
    "dynamic-desktop-cta-searchbar-2-width": "3.2291666666666665vw",
    "cta-button-1-height": "2.5rem",
    "dynamic-mobile-cta-button-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-1-height": "3.7037037037037037vh",
    "cta-button-1-width": "10rem",
    "dynamic-mobile-cta-button-1-width": "44.44444444444444vw",
    "dynamic-desktop-cta-button-1-width": "8.333333333333334vw",
    "cta-button-2-height": "2rem",
    "dynamic-mobile-cta-button-2-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-2-height": "2.962962962962963vh",
    "cta-button-2-width": "6.25rem",
    "dynamic-mobile-cta-button-2-width": "27.77777777777778vw",
    "dynamic-desktop-cta-button-2-width": "5.208333333333333vw",
    "cta-banner-1-height": "6.5rem",
    "dynamic-mobile-cta-banner-1-height": "14.606741573033707vh",
    "dynamic-desktop-cta-banner-1-height": "9.62962962962963vh",
    "cta-banner-1-width": "19.5rem",
    "dynamic-mobile-cta-banner-1-width": "86.66666666666667vw",
    "dynamic-desktop-cta-banner-1-width": "16.25vw",
    "cta-category-1-height": "6.125rem",
    "dynamic-mobile-cta-category-1-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-1-height": "9.074074074074074vh",
    "cta-category-1-width": "19.5rem",
    "dynamic-mobile-cta-category-1-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-1-width": "16.25vw",
    "cta-category-2-height": "6.125rem",
    "dynamic-mobile-cta-category-2-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-2-height": "9.074074074074074vh",
    "cta-category-2-width": "19.5rem",
    "dynamic-mobile-cta-category-2-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-2-width": "16.25vw",
    "cta-category-3-height": "6.125rem",
    "dynamic-mobile-cta-category-3-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-3-height": "9.074074074074074vh",
    "cta-category-3-width": "19.5rem",
    "dynamic-mobile-cta-category-3-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-3-width": "16.25vw",
    "cta-category-4-height": "6.125rem",
    "dynamic-mobile-cta-category-4-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-4-height": "9.074074074074074vh",
    "cta-category-4-width": "19.5rem",
    "dynamic-mobile-cta-category-4-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-4-width": "16.25vw",
    "cta-category-5-height": "6.125rem",
    "dynamic-mobile-cta-category-5-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-5-height": "9.074074074074074vh",
    "cta-category-5-width": "19.5rem",
    "dynamic-mobile-cta-category-5-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-5-width": "16.25vw",
    "cta-category-6-height": "6.125rem",
    "dynamic-mobile-cta-category-6-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-6-height": "9.074074074074074vh",
    "cta-category-6-width": "19.5rem",
    "dynamic-mobile-cta-category-6-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-6-width": "16.25vw",
    "cta-category-7-height": "6.125rem",
    "dynamic-mobile-cta-category-7-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-7-height": "9.074074074074074vh",
    "cta-category-7-width": "19.5rem",
    "dynamic-mobile-cta-category-7-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-7-width": "16.25vw",
    "cta-category-8-height": "6.125rem",
    "dynamic-mobile-cta-category-8-height": "13.764044943820224vh",
    "dynamic-desktop-cta-category-8-height": "9.074074074074074vh",
    "cta-category-8-width": "19.5rem",
    "dynamic-mobile-cta-category-8-width": "86.66666666666667vw",
    "dynamic-desktop-cta-category-8-width": "16.25vw",
    "cta-typography-1-height": "1.5rem",
    "dynamic-mobile-cta-typography-1-height": "3.3707865168539324vh",
    "dynamic-desktop-cta-typography-1-height": "2.2222222222222223vh",
    "cta-typography-1-width": "3.125rem",
    "dynamic-mobile-cta-typography-1-width": "13.88888888888889vw",
    "dynamic-desktop-cta-typography-1-width": "2.6041666666666665vw",
    "cta-typography-2-height": "1.625rem",
    "dynamic-mobile-cta-typography-2-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typography-2-height": "2.4074074074074074vh",
    "cta-typography-2-width": "5rem",
    "dynamic-mobile-cta-typography-2-width": "22.22222222222222vw",
    "dynamic-desktop-cta-typography-2-width": "4.166666666666667vw",
    "cta-typography-3-height": "1.625rem",
    "dynamic-mobile-cta-typography-3-height": "3.651685393258427vh",
    "dynamic-desktop-cta-typography-3-height": "2.4074074074074074vh",
    "cta-typography-3-width": "4rem",
    "dynamic-mobile-cta-typography-3-width": "17.77777777777778vw",
    "dynamic-desktop-cta-typography-3-width": "3.3333333333333335vw",
    "frame-background-1-width": "21rem",
    "dynamic-mobile-frame-background-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-background-1-width": "17.5vw",
    "frame-background-2-width": "21rem",
    "dynamic-mobile-frame-background-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-background-2-width": "17.5vw",
    "frame-background-2-height": "74.5rem",
    "dynamic-mobile-frame-background-2-height": "167.41573033707866vh",
    "dynamic-desktop-frame-background-2-height": "110.37037037037037vh",
    "frame-review-1-height": "13rem",
    "dynamic-mobile-frame-review-1-height": "29.213483146067414vh",
    "dynamic-desktop-frame-review-1-height": "19.25925925925926vh",
    "frame-review-1-width": "10.125rem",
    "dynamic-mobile-frame-review-1-width": "45vw",
    "dynamic-desktop-frame-review-1-width": "8.4375vw",
    "frame-toast-1-width": "22.5rem",
    "dynamic-mobile-frame-toast-1-width": "100vw",
    "dynamic-desktop-frame-toast-1-width": "18.75vw",
    "frame-toast-1-height": "4.25rem",
    "dynamic-mobile-frame-toast-1-height": "9.55056179775281vh",
    "dynamic-desktop-frame-toast-1-height": "6.296296296296297vh",
    "frame-header-1-height": "5.875rem",
    "dynamic-mobile-frame-header-1-height": "13.202247191011235vh",
    "dynamic-desktop-frame-header-1-height": "8.703703703703704vh",
    "frame-header-1-width": "22.5rem",
    "dynamic-mobile-frame-header-1-width": "100vw",
    "dynamic-desktop-frame-header-1-width": "18.75vw",
    "frame-header-2-height": "4rem",
    "dynamic-mobile-frame-header-2-height": "8.98876404494382vh",
    "dynamic-desktop-frame-header-2-height": "5.925925925925926vh",
    "frame-header-2-width": "22.5rem",
    "dynamic-mobile-frame-header-2-width": "100vw",
    "dynamic-desktop-frame-header-2-width": "18.75vw",
    "body-md2_1-paragraphSpacing": "0rem",
    "body-md_1-paragraphSpacing": "0rem",
    "body-md_2-paragraphSpacing": "0rem",
    "title-lg2_2-paragraphSpacing": "0rem",
    "title-md2_1-paragraphSpacing": "0rem",
  },
  borderRadius: {
    "cta-searchbar-1-borderRadius": "0.375rem",
    "cta-searchbar-2-borderRadiusTopLeft": "0rem",
    "cta-searchbar-2-borderRadiusTopRight": "0.375rem",
    "cta-searchbar-2-borderRadiusBottomRight": "0.375rem",
    "cta-searchbar-2-borderRadiusBottomLeft": "0rem",
    "cta-button-1-borderRadius": "0.75rem",
    "cta-button-2-borderRadius": "1.75rem",
    "cta-banner-1-borderRadius": "0.5rem",
    "cta-category-1-borderRadius": "0.5rem",
    "cta-category-2-borderRadius": "0.5rem",
    "cta-category-3-borderRadius": "0.5rem",
    "cta-category-4-borderRadius": "0.5rem",
    "cta-category-5-borderRadius": "0.5rem",
    "cta-category-6-borderRadius": "0.5rem",
    "cta-category-7-borderRadius": "0.5rem",
    "cta-category-8-borderRadius": "0.5rem",
    "frame-background-1-borderRadius": "0.5rem",
    "frame-background-2-borderRadius": "0.75rem",
    "frame-review-1-borderRadius": "0.75rem",
    "frame-toast-1-borderRadius": "0rem",
    "frame-header-1-borderRadiusTopLeft": "0rem",
    "frame-header-1-borderRadiusTopRight": "0rem",
    "frame-header-1-borderRadiusBottomLeft": "0.75rem",
    "frame-header-1-borderRadiusBottomRight": "0.75rem",
    "frame-header-2-borderRadiusTopLeft": "0rem",
    "frame-header-2-borderRadiusTopRight": "0rem",
    "frame-header-2-borderRadiusBottomLeft": "0.75rem",
    "frame-header-2-borderRadiusBottomRight": "0.75rem",
  },
  borderWidth: {
    "cta-searchbar-1-borderWidth": "0.03125rem",
    "cta-searchbar-2-borderWidth": "0.03125rem",
    "frame-review-1-borderWidth": "0.03125rem",
    "frame-header-1-borderWidthTop": "0rem",
    "frame-header-1-borderWidthRight": "0rem",
    "frame-header-1-borderWidthBottom": "0.03125rem",
    "frame-header-1-borderWidthLeft": "0rem",
    "frame-header-2-borderWidthTop": "0rem",
    "frame-header-2-borderWidthRight": "0rem",
    "frame-header-2-borderWidthBottom": "0.03125rem",
    "frame-header-2-borderWidthLeft": "0rem",
  },
  colors: {
    "cta-searchbar-1-fill": "#191919",
    "cta-searchbar-1-borderColor": "#333333",
    "cta-searchbar-2-fill": "#202020",
    "cta-searchbar-2-borderColor": "#333333",
    "cta-button-1-fill": "#3929F2",
    "cta-button-2-fill": "#3929F2",
    "cta-banner-1-fill": "#383138",
    "cta-category-1-fill": "#DB7B94",
    "cta-category-2-fill": "#EEAB5E",
    "cta-category-3-fill": "#5DC780",
    "cta-category-4-fill": "#BB94C1",
    "cta-category-5-fill": "#DA6464",
    "cta-category-6-fill": "#333333",
    "cta-category-7-fill": "#675541",
    "cta-category-8-fill": "#6E9074",
    "cta-typography-1-fill": "#7F95FF",
    "cta-typography-2-fill": "#4364EF",
    "cta-typography-3-fill": "#4364EF",
    "frame-background-1-fill": "#191919",
    "frame-background-2-fill": "#191919",
    "frame-review-1-fill": "#191919",
    "frame-review-1-borderColor": "#333333",
    "frame-toast-1-fill": "#191919",
    "frame-header-1-fill": "#121212",
    "frame-header-1-borderColor": "#333333",
    "frame-header-2-fill": "#121212",
    "frame-header-2-borderColor": "#333333",
    "on-bg-80": "#666666",
    "on-bg-105": "#838488",
    "on-bg-140": "#B2B2B2",
    "on-bg-160": "#CCCCCC",
    "on-bg-180": "#E5E5E5",
    "on-bg-190": "#F2F2F2",
    "on-bg-200": "#FFFFFF",
    "secondary-100": "#4364EF",
    "tertiary-100": "#7F95FF",
    "primary-100": "#3929F2",
    "Categories-Vitamins-1": "#89B996",
  },
  fontFamily: {
    "cta-typography-1-fontFamilies": "Circular Std, sans-serif",
    "cta-typography-2-fontFamilies": "Circular Std, sans-serif",
    "cta-typography-3-fontFamilies": "Circular Std, sans-serif",
    "body-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md2_7-fontFamily": "Circular Std, sans-serif",
    "body-lg1_1-fontFamily": "Circular Std, sans-serif",
    "body-lg1_2-fontFamily": "Circular Std, sans-serif",
    "body-md_4-fontFamily": "Circular Std, sans-serif",
    "body-md_1-fontFamily": "Circular Std, sans-serif",
    "body-sm2_2-fontFamily": "Circular Std, sans-serif",
    "body-md_7-fontFamily": "Circular Std, sans-serif",
    "body-md_3-fontFamily": "Circular Std, sans-serif",
    "body-md_2-fontFamily": "Circular Std, sans-serif",
    "body-md_5-fontFamily": "Circular Std, sans-serif",
    "body-sm2_3-fontFamily": "Circular Std, sans-serif",
    "body-md3_1-fontFamily": "Circular Std, sans-serif",
    "title-md1_1-fontFamily": "Circular Std, sans-serif",
    "title-lg5_1-fontFamily": "Circular Std, sans-serif",
    "title-lg_5-fontFamily": "Circular Std, sans-serif",
    "title-lg_1-fontFamily": "Circular Std, sans-serif",
    "title-md_2-fontFamily": "Circular Std, sans-serif",
    "title-lg2_2-fontFamily": "Circular Std, sans-serif",
    "title-md_3-fontFamily": "Circular Std, sans-serif",
    "title-md2_1-fontFamily": "Circular Std, sans-serif",
  },
  fontWeight: {
    "cta-typography-1-fontWeights": 500,
    "cta-typography-2-fontWeights": 400,
    "cta-typography-3-fontWeights": 400,
    "body-md2_1-fontWeight": 400,
    "body-md2_7-fontWeight": 500,
    "body-lg1_1-fontWeight": 500,
    "body-lg1_2-fontWeight": 700,
    "body-md_4-fontWeight": 300,
    "body-md_1-fontWeight": 400,
    "body-sm2_2-fontWeight": 400,
    "body-md_7-fontWeight": 700,
    "body-md_3-fontWeight": 500,
    "body-md_2-fontWeight": 400,
    "body-md_5-fontWeight": 300,
    "body-sm2_3-fontWeight": 300,
    "body-md3_1-fontWeight": 400,
    "title-md1_1-fontWeight": 700,
    "title-lg5_1-fontWeight": 700,
    "title-lg_5-fontWeight": 700,
    "title-lg_1-fontWeight": 500,
    "title-md_2-fontWeight": 700,
    "title-lg2_2-fontWeight": 500,
    "title-md_3-fontWeight": 500,
    "title-md2_1-fontWeight": 500,
  },
  fontSize: {
    "cta-typography-1-fontSizes": "0.75rem",
    "cta-typography-2-fontSizes": "0.875rem",
    "cta-typography-3-fontSizes": "0.75rem",
    "body-md2_1-fontSize": "0.875rem",
    "body-md2_7-fontSize": "0.875rem",
    "body-lg1_1-fontSize": "1.25rem",
    "body-lg1_2-fontSize": "1.25rem",
    "body-md_4-fontSize": "0.75rem",
    "body-md_1-fontSize": "0.75rem",
    "body-sm2_2-fontSize": "0.625rem",
    "body-md_7-fontSize": "0.75rem",
    "body-md_3-fontSize": "0.75rem",
    "body-md_2-fontSize": "0.75rem",
    "body-md_5-fontSize": "0.75rem",
    "body-sm2_3-fontSize": "0.625rem",
    "body-md3_1-fontSize": "0.6875rem",
    "title-md1_1-fontSize": "0.75rem",
    "title-lg5_1-fontSize": "1.5rem",
    "title-lg_5-fontSize": "1rem",
    "title-lg_1-fontSize": "1rem",
    "title-md_2-fontSize": "0.75rem",
    "title-lg2_2-fontSize": "1.125rem",
    "title-md_3-fontSize": "0.75rem",
    "title-md2_1-fontSize": "0.875rem",
  },
  lineHeight: {
    "cta-typography-1-lineHeights": "inherit",
    "cta-typography-2-lineHeights": "inherit",
    "cta-typography-3-lineHeights": "inherit",
    "body-md2_1-lineHeight": "inherit",
    "body-md2_7-lineHeight": "inherit",
    "body-lg1_1-lineHeight": "inherit",
    "body-lg1_2-lineHeight": "inherit",
    "body-md_4-lineHeight": "inherit",
    "body-md_1-lineHeight": "inherit",
    "body-sm2_2-lineHeight": "inherit",
    "body-md_7-lineHeight": "inherit",
    "body-md_3-lineHeight": "inherit",
    "body-md_2-lineHeight": "inherit",
    "body-md_5-lineHeight": "inherit",
    "body-sm2_3-lineHeight": "inherit",
    "body-md3_1-lineHeight": "inherit",
    "title-md1_1-lineHeight": "inherit",
    "title-lg5_1-lineHeight": "inherit",
    "title-lg_5-lineHeight": "inherit",
    "title-lg_1-lineHeight": "inherit",
    "title-md_2-lineHeight": "inherit",
    "title-lg2_2-lineHeight": "inherit",
    "title-md_3-lineHeight": "inherit",
    "title-md2_1-lineHeight": "inherit",
  },
  letterSpacing: {
    "cta-typography-1-letterSpacing": "0rem",
    "cta-typography-2-letterSpacing": "0rem",
    "cta-typography-3-letterSpacing": "0rem",
    "body-md2_1-letterSpacing": "0rem",
    "body-md2_7-letterSpacing": "0rem",
    "body-lg1_1-letterSpacing": "0rem",
    "body-lg1_2-letterSpacing": "0rem",
    "body-md_4-letterSpacing": "0rem",
    "body-md_1-letterSpacing": "0rem",
    "body-sm2_2-letterSpacing": "0rem",
    "body-md_7-letterSpacing": "0rem",
    "body-md_3-letterSpacing": "0rem",
    "body-md_2-letterSpacing": "0.01rem",
    "body-md_5-letterSpacing": "0.03rem",
    "body-sm2_3-letterSpacing": "0.02rem",
    "body-md3_1-letterSpacing": "0rem",
    "title-md1_1-letterSpacing": "0rem",
    "title-lg5_1-letterSpacing": "0rem",
    "title-lg_5-letterSpacing": "0rem",
    "title-lg_1-letterSpacing": "0rem",
    "title-md_2-letterSpacing": "0rem",
    "title-lg2_2-letterSpacing": "0rem",
    "title-md_3-letterSpacing": "0rem",
    "title-md2_1-letterSpacing": "0rem",
  },
};

export const website_mobile_plugin_components = {
  ".typography-cta-typography-1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typography-2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typography-3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md2_7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "1.25rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md_1": {
    fontSize: "0.75rem",
    fontWeight: 400,
    fontFamily: "Circular Std, sans-serif",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-body-sm2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md_7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.01rem",
  },
  ".typography-body-md_5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.03rem",
  },
  ".typography-body-sm2_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    textDecoration: "none",
    letterSpacing: "0.02rem",
  },
  ".typography-body-md3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.6875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg5_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg_5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
  },
  ".typography-title-md_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.125rem",
    letterSpacing: "0rem",
  },
  ".typography-title-md_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
  },
  ".composition-cta-searchbar-1": {
    height: "2.5rem",
    width: "21rem",
    borderRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#333333",
  },
  ".composition-cta-searchbar-2": {
    height: "2.5rem",
    width: "3.875rem",
    backgroundColor: "#202020",
    borderColor: "#333333",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-cta-button-1": {
    height: "2.5rem",
    width: "10rem",
    borderRadius: "0.75rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-button-2": {
    height: "2rem",
    width: "6.25rem",
    borderRadius: "1.75rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-banner-1": {
    height: "6.5rem",
    width: "19.5rem",
    backgroundColor: "#383138",
    borderRadius: "0.5rem",
  },
  ".composition-cta-category-1": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#DB7B94",
  },
  ".composition-cta-category-2": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#EEAB5E",
  },
  ".composition-cta-category-3": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#5DC780",
  },
  ".composition-cta-category-4": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#BB94C1",
  },
  ".composition-cta-category-5": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#DA6464",
  },
  ".composition-cta-category-6": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#333333",
  },
  ".composition-cta-category-7": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#675541",
  },
  ".composition-cta-category-8": {
    height: "6.125rem",
    width: "19.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#6E9074",
  },
  ".composition-cta-typography-1": {
    backgroundColor: "#7F95FF",
    height: "1.5rem",
    width: "3.125rem",
  },
  ".composition-cta-typography-2": {
    backgroundColor: "#4364EF",
    height: "1.625rem",
    width: "5rem",
  },
  ".composition-cta-typography-3": {
    backgroundColor: "#4364EF",
    height: "1.625rem",
    width: "4rem",
  },
  ".composition-frame-background-1": {
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-background-2": {
    width: "21rem",
    height: "74.5rem",
    borderRadius: "0.75rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-review-1": {
    height: "13rem",
    width: "10.125rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
    borderColor: "#333333",
  },
  ".composition-frame-toast-1": {
    width: "22.5rem",
    height: "4.25rem",
    borderRadius: "0rem",
    backgroundColor: "#191919",
  },
  ".composition-frame-header-1": {
    height: "5.875rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderColor: "#333333",
    borderTopWidth: "0rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0.03125rem",
    borderLeftWidth: "0rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomLeftRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
  },
  ".composition-frame-header-2": {
    height: "4rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderColor: "#333333",
    borderTopWidth: "0rem",
    borderRightWidth: "0rem",
    borderBottomWidth: "0.03125rem",
    borderLeftWidth: "0rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomLeftRadius: "0.75rem",
    borderBottomRightRadius: "0.75rem",
  },
};
